<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-flex xs12 mb-3>
        <h2 class="darkblue--text fs-16 lh-16 font-weight-700">
          GUIDELINE TEXT MENU
        </h2>
        <v-breadcrumbs
          class="px-0 text-capitalize"
          :items="breadcrumbs"
        ></v-breadcrumbs>
      </v-flex>
      <v-card>
        <v-card-title>
          <v-flex xs9 class="pl-1 text-capitalize">
            {{
              isDetail
                ? 'Guideline Text Menu Details'
                : id
                ? type + ' Guideline Text Menu'
                : 'Create New Guideline Text Menu'
            }}
          </v-flex>
          <v-flex xs3 class="text-right" v-if="isDetail || isEdit">
            <v-icon @click="getDetail" title="refresh">refresh</v-icon>
          </v-flex>
        </v-card-title>
        <ValidationObserver ref="obs">
          <v-form @submit.prevent="save" class="pa-5">
            <v-layout row wrap>
              <v-flex xs12 class="pa-0">
                <v-flex xs8 class="pr-0">
                  <ValidationProvider
                    name="Menu"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label class="darkblue--text">Menu</label>
                    <v-text-field
                      id="menu"
                      single-line
                      outlined
                      dense
                      placeholder="Menu"
                      v-model="items.menu"
                      required
                      :error-messages="errors"
                      :disabled="isDetail"
                    />
                  </ValidationProvider>

                  <v-row v-if="items.subMenu.length > 0">
                    <v-col :cols="isDetail ? '10' : '8'" class="py-0 pr-0">
                      <label class="darkblue--text">Sub Menu</label>
                    </v-col>
                    <v-col class="py-0">
                      <label class="darkblue--text">Order</label>
                    </v-col>
                  </v-row>
                  <v-row v-for="(sub, index) in items.subMenu" :key="index">
                    <template v-if="!sub.isDeleted">
                      <v-col :cols="isDetail ? '10' : '8'" class="py-0 pr-0">
                        <ValidationProvider
                          name="Sub Menu"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            id="subMenu"
                            single-line
                            outlined
                            dense
                            placeholder="Sub Menu"
                            v-model="sub.menu"
                            :disabled="isDetail"
                            required
                            :error-messages="errors"
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="2" class="py-0 pr-0">
                        <ValidationProvider
                          name="Order"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            id="order"
                            single-line
                            outlined
                            dense
                            placeholder="Order"
                            v-model="sub.order"
                            :disabled="isDetail"
                            type="number"
                            required
                            :error-messages="errors"
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-spacer />
                      <v-col cols="auto" class="py-1" v-if="!isDetail">
                        <v-btn
                          style="margin-top: 1px"
                          color="red"
                          dark
                          @click="confirmRemove(index, sub.id)"
                          ><v-icon large class="icon-medium"
                            >delete_outline</v-icon
                          ></v-btn
                        >
                      </v-col>
                    </template>
                  </v-row>
                  <v-btn v-if="!isDetail" color="green" dark @click="addRow"
                    ><v-icon>add</v-icon> Add Sub Menu</v-btn
                  >
                </v-flex>
              </v-flex>
            </v-layout>
            <v-card-actions class="text-right pt-6 px-0">
              <v-spacer></v-spacer>
              <v-flex xs2 right>
                <v-btn
                  id="btn-cancel"
                  dark
                  rounded
                  color="red"
                  block
                  :to="{ name: 'cmsMenu' }"
                >
                  {{ id === 'id' ? 'Cancel' : 'Back' }}
                </v-btn>
              </v-flex>
              <v-flex xs2 right v-if="!isDetail" class="ml-4">
                <v-btn
                  id="btn-save"
                  dark
                  rounded
                  color="blue darken-3"
                  block
                  @click="saveConfirm()"
                >
                  Save
                </v-btn>
              </v-flex>
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </v-card>
    </v-container>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import ProgressDialog from '../../../components/progress_dialog';
import 'sweetalert2/src/sweetalert2.scss';

export default {
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    'progress-dialog': ProgressDialog
  },
  props: ['id', 'type'],
  data() {
    return {
      listMenu: [],
      items: {
        menu: '',
        subMenu: []
      },
      baseUrl: process.env.VUE_APP_BASE_URL,
      customToolbar: [
        [{ font: [] }],
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        [{ size: ['small', false, 'large', 'huge'] }],
        ['bold', 'italic', 'underline', 'strike'],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' }
        ],
        [{ header: 1 }, { header: 2 }],
        ['blockquote', 'code-block'],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        [{ script: 'sub' }, { script: 'super' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ color: [] }, { background: [] }],
        ['link', 'image'],
        [{ direction: 'rtl' }],
        ['clean']
      ],
      loading: false,
      progressDialogLoading: false,
      search: '',
      isDetail: false,
      isEdit: false,
      breadcrumbs: [
        {
          text: 'Content Management',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'Guideline Text Menu List',
          disabled: true,
          href: 'breadcrumbs_link_1'
        },
        {
          text: this.type + ' Guideline Text Menu',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ]
    };
  },
  mounted() {
    if (this.id !== 'id') {
      if (this.type === 'detail') {
        this.isDetail = true;
        this.isEdit = false;
        this.getDetail();
      } else if (this.type === 'edit') {
        this.isEdit = true;
        this.isDetail = false;
        this.getDetail();
      }
    } else {
      setTimeout(() => {
        this.progressDialogLoading = false;
        this.loading = false;
      }, 800);
    }
  },
  watch: {},
  computed: {},
  methods: {
    remove(index, id) {
      if (this.isEdit) {
        return (this.items.subMenu = this.items.subMenu.map(item => {
          console.log(item.id === id);
          if (item.id === id) {
            item.isDeleted = true;
          }
          return { ...item };
        }));
      } else {
        console.log(index);
        return this.items.subMenu.splice(index, 1);
      }
    },
    confirmRemove(index, id) {
      Swal.fire({
        title: 'Are you sure?',
        text:
          'If you delete this sub menu, the guideline text will be deleted too and you can not recover this sub menu.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it'
      }).then(result => {
        if (result.value) {
          this.remove(index, id);
          Swal.fire(
            'Deleted',
            'Sub menu has been deleted successfully',
            'success'
          );
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire('Cancelled', 'Sub menu has been undeleted', 'error');
        }
      });
    },
    addRow() {
      return this.items.subMenu.push({
        id: null,
        menu: '',
        isDeleted: false,
        order: null
      });
    },
    async getDetail() {
      this.progressDialogLoading = true;
      this.loading = true;
      await this.$store
        .dispatch('guidelineMenu/detail', this.id)
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            console.log('data');
            this.items.menu = data.data.menu;
            this.items.subMenu = data.data.detail.map(item => {
              return {
                id: item.id,
                menu: item.name,
                isDeleted: false,
                order: item.order
              };
            });
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    async saveConfirm() {
      const validated = await this.$refs.obs.validate();
      if (validated) {
        Swal.fire({
          title: '',
          text: `Are you sure want to ${
            this.isEdit ? 'update' : 'save'
          } this guideline text menu?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: `Yes, ${this.isEdit ? 'update' : 'save'} it!`,
          cancelButtonText: 'No, cancel it!'
        }).then(result => {
          if (result.value) {
            this.saveGuideline();
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            Swal.fire(
              'Cancelled',
              `Guideline text menu ${
                this.isEdit ? 'update' : 'creation'
              } has been cancelled`,
              'error'
            );
          }
        });
      }
    },
    saveGuideline() {
      this.progressDialogLoading = true;
      this.loading = true;
      const param = {
        menu: this.items.menu,
        subMenu: this.items.subMenu.map(item => {
          return {
            menu: item.menu,
            order: item.order
          };
        })
      };
      if (this.isEdit) {
        this.$store
          .dispatch('guidelineMenu/update', { id: this.id, params: this.items })
          .then(data => {
            this.progressDialogLoading = false;
            this.loading = false;
            if (data.code === 200) {
              Swal.fire(
                'Success!',
                `Guideline text menu has been ${
                  this.isEdit ? 'updated' : 'created'
                } successfully `,
                'success'
              );
              this.$router.push({
                name: 'cmsMenu'
              });
            } else {
              Swal.fire('Failed!', data.response.data.message.text_en, 'error');
            }
          })
          .catch(err => {
            Swal.fire('Failed!', err.response.data.message.text_en, 'error');
            this.progressDialogLoading = false;
            this.loading = false;
          });
      } else {
        this.$store
          .dispatch('guidelineMenu/create', param)
          .then(data => {
            this.progressDialogLoading = false;
            this.loading = false;
            if (data.code === 200) {
              Swal.fire(
                'Success!',
                `Guideline text menu has been ${
                  this.isEdit ? 'updated' : 'created'
                } successfully `,
                'success'
              );
              this.$router.push({
                name: 'cmsMenu'
              });
            } else {
              Swal.fire('Failed!', data.response.data.message.text_en, 'error');
            }
          })
          .catch(err => {
            Swal.fire('Failed!', err.response.data.message.text_en, 'error');
            this.progressDialogLoading = false;
            this.loading = false;
          });
      }
    }
  }
};
</script>
<style>
.icon-medium {
  font-size: 25px !important;
}
</style>
